<template>
  <div class="grafico-line-container">
    <div class="grafico-line-canvas-wrapper">
      <canvas
        ref="elemento"
        id="lineCurvaDesgasteNeumatico"
      ></canvas>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
Chart.register(ChartDataLabels);

export default {
  props: ["Labels", "DatosGrafico", "title", "Labelscale_x", "Labelscale_y"],
  data() {
    return {
      chartInstance: null,
    };
  },
  methods: {
    generarGrafico: function () {
      this.$nextTick(() => {
        if (this.chartInstance) {
          this.chartInstance.destroy();
          this.chartInstance = null;
        }
        var popCanvas =
          this.$refs.elemento ||
          document.getElementById("lineCurvaDesgasteNeumatico");
        if (!popCanvas) return;
        this.chartInstance = new Chart(popCanvas, {
          plugins: [ChartDataLabels],
          type: "line",
          data: {
            labels: this.Labels,
            datasets: this.DatosGrafico,
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              title: {
                display: true,
                text: this.title,
              },
              datalabels: {
                font: {
                  size: "0",
                },
              },
            },
            interaction: {
              mode: "index",
              intersect: false,
            },
            scales: {
              x: {
                display: true,
                suggestedMin: 0,
                title: {
                  display: true,
                  text: this.Labelscale_x,
                },
              },
              y: {
                display: true,
                title: {
                  display: true,
                  text: this.Labelscale_y,
                },
                suggestedMin: 0,
                suggestedMax: 10,
              },
            },
          },
        });
      });
    },
  },
  watch: {
    DatosGrafico: {
      deep: true,
      handler() {
        this.generarGrafico();
      },
    },
    Labels: {
      deep: true,
      handler() {
        this.generarGrafico();
      },
    },
  },
  mounted() {
    this.generarGrafico();
  },
  beforeDestroy() {
    if (this.chartInstance) {
      this.chartInstance.destroy();
      this.chartInstance = null;
    }
  },
};
</script>

<style scoped>
.grafico-line-container {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}

.grafico-line-canvas-wrapper {
  position: relative;
  width: 100%;
  min-width: 620px;
  height: 380px;
}

@media (max-width: 600px) {
  .grafico-line-canvas-wrapper {
    min-width: 580px;
    height: 330px;
  }
}

/* Scrollbar estilizada */
.grafico-line-container::-webkit-scrollbar {
  height: 6px;
}
.grafico-line-container::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 4px;
}
.grafico-line-container::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}
.grafico-line-container::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
</style>
